import { BaseAPI } from './BaseAPI.js'
import { Role } from '../types/index.js'

export default class RolesAPI extends BaseAPI<Role> {
  override get resource(): string {
    return '/roles'
  }
}
